import React from "react";
import { FormControl, Box, makeStyles, Checkbox, FormControlLabel, Theme, FormHelperText, Typography, Link } from "@material-ui/core";

export type CheckboxProps = {
  selected?: boolean;
  text?: string;
};

export type CheckboxGroupProps = {
  onChange: Function;
  id?: string;
  values: CheckboxProps;
  showError?: boolean;
  errorMessage?: string;
  readMore?: string;
  readMoreUrl?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    "& span:first-child": {
      backgroundColor: "transparent",
      alignSelf: "flex-start",
    },
    "& span:last-child": {
      color: theme.palette.text.secondary,
      fontWeight: 400,
    },
  },
}));

export const CheckboxGroupBase: React.FC<CheckboxGroupProps> = (props: CheckboxGroupProps) => {
  const classes = useStyles();

  const input = React.createRef<HTMLInputElement>();

  function handleError() {
    input.current?.focus();
  }

  setTimeout(() => {
    if (props.showError) handleError();
  }, 1);

  function handleOnChange(event: React.ChangeEvent<HTMLInputElement>, changeEvent?: Function) {
    // if value is not changed, newValue === null
    if (event != null && changeEvent) {
      let newValues;
      if (props.id) {
        newValues = {
          addOnInternalCode: props.id,
          newState: event.target.checked,
        };
      } else {
        newValues = event.target.checked;
      }

      changeEvent(newValues);
    }
  }

  const handleLabelText = (
    <Typography variant='body1' component='p' color='secondary'>
      {props.values.text}{" "}
      {props.readMore && (
        <Link target='_blank' href={props?.readMoreUrl} style={{ cursor: "pointer", textDecoration: "underline" }}>
          {props?.readMore}
        </Link>
      )}
    </Typography>
  );

  return (
    <Box marginY={1} id={"ws-checkbox-" + props.id}>
      <FormControl fullWidth error={props.showError}>
        <FormControlLabel
          className={classes.label}
          control={
            <Checkbox
              id={props.id}
              checked={props.values.selected}
              onChange={event => handleOnChange(event, props.onChange)}
              inputRef={input}
            />
          }
          label={handleLabelText}
        />
        {props.showError && <FormHelperText>{props.errorMessage}</FormHelperText>}
      </FormControl>
    </Box>
  );
};
